import { useEffect } from 'react';
import { EnabledRepositoriesStatus, Step } from 'shared/InstallationDialog';
import { useMultiStepDialog } from 'shared/MultiStepDialog';
import { renderTranslations, spawn } from 'utils/translations';
import { useAzureInstallation } from '../azureInstallationContext';
import { ENABLE_QODO_TRANSLATION_KEY } from '../consts';

export const EnableQodo = () => {
  const spawnStep = spawn(ENABLE_QODO_TRANSLATION_KEY);
  const { syncedCount = 0 } = useAzureInstallation();

  const {
    currentStepIndex,
    setCurrentStepAsFurthestStepReached,
    setEarliestStepAvailable,
  } = useMultiStepDialog();

  useEffect(() => {
    setCurrentStepAsFurthestStepReached();
    setEarliestStepAvailable(currentStepIndex);
  }, [
    currentStepIndex,
    setCurrentStepAsFurthestStepReached,
    setEarliestStepAvailable,
  ]);

  return (
    <Step
      title={spawnStep('title')}
      description={renderTranslations(
        `${ENABLE_QODO_TRANSLATION_KEY}.description`,
      )}
    >
      <div className="flex flex-col gap-8">
        <EnabledRepositoriesStatus
          title={spawnStep('enabled-message', { count: syncedCount })}
          description={spawnStep('enabled-description')}
        />
      </div>
    </Step>
  );
};
